"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCustom = exports.TextCustomContext = void 0;
const React = __importStar(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("./helpers");
const BaseComponent = props => {
    const { tag = components_core_1.TextTag.div, children, className } = props;
    const Component = components_core_1.TextTag[tag];
    return React.createElement(Component, { className: className }, children);
};
BaseComponent.displayName = 'BaseComponent';
function getTextDecoration(props) {
    if (typeof props.strikethrough === 'boolean') {
        return props.strikethrough ? 'line-through' : 'initial';
    }
    return;
}
const StyledTextCustomComponent = (0, components_core_1.styled)(BaseComponent) `
  ${(props) => {
    const { wordBreak, theme } = props;
    //TODO: Fix me properly please. Research why the theme is empty
    let cssFontStyle;
    if (theme && theme.fonts) {
        cssFontStyle = (0, helpers_1.createFontStyles)(props.style, props.appearance || components_core_1.TokenTextAppearance.copy200, theme);
    }
    return `
        margin: -0.11em 0 0.11em 0;
        word-break: ${wordBreak ? 'break-word' : 'inherit'};
        text-decoration: ${getTextDecoration};
        white-space: ${props.whiteSpace};
        vertical-align: baseline;
        ${cssFontStyle ? cssFontStyle : ''};
        `;
}}
`;
StyledTextCustomComponent.displayName = 'StyledTextCustomComponent';
exports.TextCustomContext = React.createContext({});
function TextCustomComponent(props) {
    const { appearance, style, children, strikethrough, tag, wordBreak, whiteSpace } = props;
    return (React.createElement(exports.TextCustomContext.Consumer, null, context => {
        const textAppearance = appearance || context.textAppearance || components_core_1.TokenTextAppearance.copy200;
        const textTag = tag || (context.textAppearance && components_core_1.TextTag.span);
        const textStyle = context.textStyle && style
            ? (0, helpers_1.mergeTextStyle)(context.textStyle, style)
            : style || context.textStyle;
        return (React.createElement(StyledTextCustomComponent, { appearance: textAppearance, style: textStyle, tag: textTag, wordBreak: wordBreak, whiteSpace: whiteSpace, strikethrough: strikethrough },
            React.createElement(exports.TextCustomContext.Provider, { value: { textAppearance, textStyle } }, children)));
    }));
}
const TextCustom = props => (React.createElement(TextCustomComponent, Object.assign({}, props), props.children));
exports.TextCustom = TextCustom;
